module.exports = {"svg":{"$":{"t":"1528428875721","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"5764","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M511.04256 115.30752l121.4976 274.32448 298.32192 31.95904-223.36 200.32512 61.78816 293.58592-259.52768-150.528-260.13184 149.504 62.95552-293.36064-222.55616-201.19552 298.42944-30.77632 122.58304-273.83808z","fill":"#ffffff","p-id":"5765"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/fiveStar.svg
// module id = KbIa
// module chunks = 1